import { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';

export const DTicketSubscriptionPauseSkeleton: FC = () => {
	return (
		<Stack gap={3}>
			{/* Section title and info button */}
			<Stack gap={2}>
				<Stack gap="8px">
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
					>
						<Skeleton variant="text" width="50%" height={28} />
						<Skeleton variant="circular" width={24} height={24} />
					</Stack>
					<Skeleton variant="text" width="90%" height={20} />
					<Skeleton variant="text" width="70%" height={20} />
				</Stack>

				{/* Radio buttons - 3 pause options */}
				<Stack gap="12px">
					{Array.from({ length: 3 }, (_, i) => (
						<Skeleton key={i} variant="rounded" width="100%" height={56} />
					))}
				</Stack>

				{/* Pause button */}
				<Skeleton variant="rounded" width="100%" height={48} />
			</Stack>
		</Stack>
	);
};
